import Vue from 'vue'
import EventBus from '@/plugins/eventbus'
import UserMenu from '@/components/UserMenu'

let component = null

Vue.prototype.$userMenu = {
 open(e, user) {
    if (!component) return
    component.$emit('inspect', { e, user })
  },
}

EventBus.$once('app.created', vm => {
  const UserMenuComponent = Vue.extend(UserMenu)
  component = new UserMenuComponent({
    el: document.createElement('div'),
    parent: vm,
  })
})
